import api from './api';

/**
 * Frontend service for the AI Help Assistant.
 *
 * Backend: apps.ai_assistant (see EEE/urls.py → /api/help-assistant/).
 * Uses the shared `api` axios instance, which adds CSRF + tenant + JWT headers.
 */
const BASE = '/api/help-assistant';

export const helpAssistantService = {
  chat: (payload) => api.post(`${BASE}/chat/`, payload),
  feedback: (payload) => api.post(`${BASE}/feedback/`, payload),
  getSuggestions: (moduleTag = '') =>
    api.get(`${BASE}/suggestions/`, { params: moduleTag ? { module: moduleTag } : {} }),
  listConversations: () => api.get(`${BASE}/conversations/`),
  getConversation: (sessionUid) => api.get(`${BASE}/conversations/${sessionUid}/`),
  health: () => api.get(`${BASE}/health/`),
  reindex: (articleIds) => api.post(`${BASE}/admin/reindex/`, articleIds ? { article_ids: articleIds } : {}),
};

export default helpAssistantService;
